module.exports = __webpack_public_path__ + "img/ico_math_minus.149fceaf.svg";